import keycloakService from '../../keycloak_service';

import { putRequestToKeycloak } from '../api_utils';

const resetUserPassword = (userId = null, password = '', isTemporary = false) => {
  const keycloakHeader = keycloakService.getAuthHeader();
  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
    body: JSON.stringify({
      value: password,
      temporary: isTemporary,
    })
  };


  const realm = keycloakService.keycloak.realm || null;
  const keycloakEndpoint = `admin/realms/${realm}/users/${userId}/reset-password`;

  return putRequestToKeycloak(keycloakEndpoint, fetchOptions);
};

export default resetUserPassword;
